<template>
	<div>
		<div :class="isPc == true ? 'lineImgInfo warp' : ''">
			<div v-if="isPc == true" class="manager_nav">
				<div class="horizontal-container">
					<div class="scroll-wrapper" ref="scroll">
						<div class="scroll-content bluefont">
							<div
								class="scroll-item"
								:style="tabarlistCur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
								@click="tabarchange(index)"
								v-for="(item, index) in tabarlist"
								:key="index"
							>
								<p>{{ item }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="isPc == false" class="mob-tabar">
				<ul class="warp-mob bluefont">
					<li
						:style="tabarlistCur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
						@click="tabarchange(index)"
						v-for="(item, index) in tabarlist"
						:key="index"
					>
						{{ item }}
					</li>
				</ul>
			</div>

			<div :class="isPc == true ? 'lineImgInfo_list' : 'lineImgInfo_list-mob warp-mob'">
				<ul>
					<li @click="getpage(item.id)" v-for="(item, index) in data" :key="index">
						<img :src="item.coverimage" />
						<div class="lineImgInfo_list_text">
							<div class="lineImgInfo_list_text_title">
								<h1>{{ item.title }}</h1>
								<p v-if="isPc == true">{{ item.createtime }}</p>
							</div>
							<div class="lineImgInfo_list_text_cont">{{ item.introduction }}</div>
						</div>
					</li>
				</ul>
			</div>
			<div v-if="isPc == true" class="lineImgInfo_pagecut warp">
				<el-pagination
					@current-change="handleCurrentChange"
					background
					:current-page="currentPage"
					layout="prev, pager, next"
					:total="data_length"
					:page-size="page_size"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import BScroll from '@better-scroll/core';
export default {
	name: 'WebLijinhospitalBuilding',

	data() {
		return {
			tabarlist: [],
			pid: 24,
			isPc: true,
			tabarlistCur: 0,
			data: null,
			currentPage: 1,
			data_length: 0,
			page_size: 5
		};
	},

	mounted() {
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		this.getdata(0);
		this.init();
	},

	methods: {
		handleCurrentChange(pageNumber) {
			this.currentPage = pageNumber;
			this.getdata(this.tabarlistCur);
		},
		tabarchange(index) {
			this.currentPage = 1;
			this.tabarlistCur = index;
			this.getdata(this.tabarlistCur);
		},
		init() {
			this.bs = new BScroll(this.$refs.scroll, {
				scrollX: true,
				probeType: 3 // listening scroll event
			});
			this.bs.on('scrollStart', () => {
				console.log('scrollStart-');
			});
			this.bs.on('scroll', () => {
				console.log('scrolling-');
			});
			this.bs.on('scrollEnd', () => {
				console.log('scrollingEnd');
			});
		},
		// 内容页
		getpage(e) {
			this.$router.push({
				path: '/content',
				query: { title: this.tabarlist[this.tabarlistCur], id: e }
			});
		},
		getdata(i) {
			let _t = this;
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					pid: _t.pid
				}
			})
				.then((res) => {
					//请求成功
					console.log('article', res.data.data);
					let plist = res.data.data;
					let index_arr = [];
					for (var i1 = 0; i1 < plist.length; i1++) {
						_t.tabarlist[i1] = plist[i1]['nickname'];
						index_arr[i1] = plist[i1]['id'];
					}
					let category_id = index_arr[i];
					this.$axios({
						url: 'http://www.ljxzxyy.cn/api/index/article',
						params: {
							category_id: category_id,
							num: this.page_size,
							page: this.currentPage
						}
					})
						.then((res) => {
							//请求成功
							console.log('article', res.data);
							this.data = res.data.data.list;
							this.data_length = res.data.data.count;
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				})
				.catch((error) => {
					//请求失败
					console.log('article', error);
				});
		}
	}
};
</script>

<style lang="scss" scoped></style>
